// extracted by mini-css-extract-plugin
export default {"step":"Steps_step__2qXND","stepActive":"Steps_stepActive__XqAac","border":"Steps_border__XjHcw"};